import React, { ReactElement } from 'react';
import SingleProgress from 'components/ui/single-progress/main/Main';

const Main: React.FC = (): ReactElement => {
  return <SingleProgress />;
};

export default Main;
